import * as projectService from '@/services/projectService.js'

export default {
    getData: function (options = {'dateInterval': true}) {
        return new Promise((resolve, reject) => {
            if (!this.$store.state.config.loaded) return
            this.rows = []
            this.loading = true
            if (options.dateInterval === true) {
                projectService.between(this.$store.getters.getStartDate, this.$store.getters.getEndDate, this.$store.getters.getCurrentDepartment, this.params, response => {
                    this.rows = response.data
                    this.loading = false
                    this.$emit('finishedLoading', this.rows.length)
                    resolve(response.data)
                }, (err) => {
                    reject(err)
                })
            } else {
                projectService.find(this.params, response => {
                    this.rows = response.data
                    this.loading = false
                    this.$emit('finishedLoading', this.rows.length)
                    resolve(response.data)
                }, (err) => {
                    reject(err)
                })
            }
        })
    },
    searchOptions: {
        enabled: true,
        trigger: 'enter',
        placeholder: 'Søg og tryk enter ...',
        skipDiacritics: true
    },
    paginationOptions: {
        enabled: true,
        perPage: 30,
        rowsPerPageLabel: 'Rækker pr. side',
        allLabel: 'Alle',
        nextLabel: 'Næste',
        prevLabel: 'Forrige',
        ofLabel: 'af',
        pageLabel: 'side'
    },
    sortOptions: {
        enabled: true
    }
}



// WEBPACK FOOTER //
// ./src/components/tables/projects/shared.js